import React from 'react';
import { forEach, groupBy, uniq, without, flatten } from 'lodash';
import { all } from 'axios';
import * as Yup from 'yup';

import Form from '~/components/WidgetContainer/Form';

import ReferenceDataProvider from '~/utils/reference-data/context';

import {
  referenceAdminInstance as ReferenceAdmin,
} from '~/utils';

const reduceConfigToObjectJson = conf =>
  [
    'color',
    'refreshInterval',
    'sourceUid',
    'widgetType',
    'dimension',
    'inverse',
    'isActive',
    'sortOrder',
  ].reduce((a, m) => {
    const memo = conf[m];

    return {
      ...a,
      [m]: typeof memo === 'object' ? memo.id || memo.color || memo.value : memo,
    };
  }, {});

const WidgetContainers = () => (
  <ReferenceDataProvider
    type="ReferenceWidgetContainer"
    config={{
      customFields: {
        config: {
          component: Form,
          validationSchema: Yup.array().of(Yup.object().shape({
            color: Yup.mixed().required(),
            type: Yup.mixed().required(),
            sortOrder: Yup.mixed().required(),
          })).min(1),
        },
      },
      actions: {
        afterRootSubmitSuccess: ({ r, values }) => {
          const promises = [];
          const { wcc, config } = values;
          const { data: { data } } = r;

          const wccIds = wcc.map(i => i.attributes.widgetContainerUid);

          const {
            true: oldItems,
            false: newItems,
          } = groupBy(config, conf => wccIds.includes(conf.widgetContainerUid));

          forEach(oldItems, i =>
            promises.push(ReferenceAdmin
              .put(`reference-widget-container-config/${i.id}`, {
                ...i,
                widgetContainerUid: data.id,
                optionsJson: JSON.stringify(reduceConfigToObjectJson(i)),
              })));

          forEach(newItems, i =>
            promises.push(ReferenceAdmin
              .post('reference-widget-container-config', {
                ...i,
                widgetContainerUid: data.id,
                optionsJson: JSON.stringify(reduceConfigToObjectJson(i)),
              })));

          all(promises)
            .then(() => {
              const reportViews = uniq(config.map((conf) => {
                const { report: { attributes: { reportConfigurationDefinition: rcd } } } = conf;

                const definition = JSON.parse(rcd);

                return definition.reportView;
              }));

              return ReferenceAdmin
                .get('reference-security-permission', {
                  params: {
                    securityPermissionName: 'hasAppSponsor',
                  },
                })
                .then(({ data: { data: p } }) => {
                  let sponsorPermission;

                  if (p.length) {
                    [sponsorPermission] = p;
                  }

                  return all(reportViews.map(viewName =>
                    ReferenceAdmin
                      .get('reference-database-view-permission', {
                        params: {
                          securityPermissionUid: sponsorPermission.id,
                          viewName,
                        },
                      })))
                    .then((d) => {
                      if (d.length) {
                        const dvp = flatten(d.map(dd => dd.data.data))
                          .map(dd => dd.attributes.viewName);
                        const newViewsToPermiss = without(reportViews, ...dvp);

                        return all(newViewsToPermiss.map(viewName =>
                          ReferenceAdmin
                            .post('reference-database-view-permission', {
                              viewName,
                              securityPermissionUid: sponsorPermission.id,
                              viewSchema: 'public',
                            })));
                      }

                      return d;
                    });
                });
            });
        },
      },
    }}
  />
);

export default WidgetContainers;
